import React from 'react';
import type { ReactNode, FC } from 'react';
import { match } from 'variant';
import { useAsync, Spinner } from '@wix/cli-ui-kit';
import { I18nProvider } from '@wix/cli-i18n';
import type {
  AuthStrategy,
  AuthStrategyState,
} from '../auth-strategies/index.js';
import { Login } from './Login.js';
import { WarnLegacyAuthData } from './WarnLegacyAuthData.js';
import messages from '../messages.json' with { type: 'json' };

interface Props {
  authStrategy: AuthStrategy;
  onLogin: (data: AuthStrategyState) => void;
  onError: (error: unknown) => void;
  children: (data: AuthStrategyState) => ReactNode;
}

export const EnsureLoggedIn: FC<Props> = ({
  authStrategy: { login, isLoggedIn },
  onLogin,
  onError,
  children,
}) => {
  const { status, merge: updateAccountAuth } = useAsync(isLoggedIn, [], {
    onSuccess: (result) => {
      if (result) {
        onLogin(result);
      }
    },
    onError,
  });

  return match(status, {
    Loading: () => <Spinner />,
    Error: () => null,
    Success: ({ result: accountAuth }) => {
      if (accountAuth == null) {
        return (
          <I18nProvider messages={messages}>
            <WarnLegacyAuthData>
              <Login
                loginFn={login}
                onLogin={(data) => {
                  updateAccountAuth({ result: data });
                  onLogin(data);
                }}
                onError={onError}
              />
            </WarnLegacyAuthData>
          </I18nProvider>
        );
      }

      return children(accountAuth);
    },
  });
};
